import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card, Col, Icon, Row, Skeleton, Statistic, Tooltip} from 'antd';
import {ReactComponent as MinersIcon} from '../../../assets/img/miners-icon.svg';
import {ReactComponent as MinersIconActive} from '../../../assets/img/miners-icon-active.svg';
import {ReactComponent as MinersIconInactive} from '../../../assets/img/miners-icon-inactive.svg';
import TranslatedText from '../../TranslatedText';
import {getMinersLoading, getWorkersCount} from '../../../redux/selectors/workers';
import {withRouter} from 'react-router';
import { PROFILE_PAGE, WORKERS_PAGE } from '../../../configuration/paths';
import {MINING_ADDRESS} from '../../../services/constants';
import {showConfirmation} from '../../../services/notifications';
import { profileSelector, walletSelector } from '../../../redux/selectors/user';
import {ReactComponent as WarningTriangle} from '../../../assets/img/warning-triangle.svg';


class Miners extends React.PureComponent {
  constructor(props) {
    super(props);
    this.copyUrl = this.copyUrl.bind(this);
  }


  copyUrl() {
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = MINING_ADDRESS;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    showConfirmation(
      <TranslatedText transKey="dashboard.miners.copyNotificationTitle"/>,
      <TranslatedText transKey="dashboard.miners.copyNotificationContent"/>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Card
          id="miners-card"
          title={<TranslatedText transKey="dashboard.miners.title"/>}
          extra={<Button onClick={() => this.props.history.push(WORKERS_PAGE)} type="primary" size="large"><TranslatedText transKey="dashboard.miners.showAll"/></Button>}
          bordered={false}
        >
          {
            this.props.isLoading
              ? <Skeleton active paragraph={false} />
              : <Row className="miners-widget-activity-row">
                <Col xs={24} xl={8}>
                  <Statistic title={<TranslatedText transKey="dashboard.miners.all"/>} value={this.props.workersCount.all} prefix={<MinersIcon/>}/>
                </Col>
                <Col xs={24} xl={8}>
                  <Statistic className="active-miners" title={<TranslatedText transKey="dashboard.miners.active"/>} value={this.props.workersCount.active} prefix={<MinersIconActive/>}/>
                </Col>
                <Col xs={24} xl={8}>
                  <Statistic className="inactive-miners" title={<TranslatedText transKey="dashboard.miners.inactive"/>} value={this.props.workersCount.inactive} prefix={<MinersIconInactive/>}/>
                </Col>
              </Row>
          }
        </Card>
        <Card
          id="wallet-card"
          title={<TranslatedText transKey="dashboard.miners.address"/>}
          extra={
            <Tooltip title={<TranslatedText transKey="dashboard.miners.toolTip"/>} placement="right">
              <Icon type="info-circle"/>
            </Tooltip>
          }
          bordered={false}
        >
          {
            this.props.profile.loading
              ? <Skeleton active title={ false } paragraph={ { rows: 1, width: '90%' } }/>
              : this.props.wallet
              ? <Row>
                <Col xs={ 24 } xl={ 18 }>
                  <span className="mining-address">{ MINING_ADDRESS }</span>
                </Col>
                <Col xs={ 24 } xl={ 4 }>
                  <Button type="primary" onClick={ this.copyUrl }>
                    <TranslatedText transKey="dashboard.miners.copyClipboard"/>
                  </Button>
                </Col>
              </Row>
              : <Row className="empty-wallet-warning-row">
                <Col xs={ 24 } xl={ 16 } className="empty-wallet-warning">
                  <WarningTriangle/>
                  <span><TranslatedText transKey="dashboard.miners.miningAddressNotSet"/></span>
                </Col>
                <Col xs={ 24 } xl={ 6 }>
                  <Button type="primary" onClick={ () => this.props.history.push(PROFILE_PAGE) }>
                    <TranslatedText transKey="dashboard.miners.goToSettings"/>
                  </Button>
                </Col>
              </Row>
          }
        </Card>
      </React.Fragment>
    );
  }
}

Miners.propTypes = {
  workersCount: PropTypes.shape({
    all: PropTypes.number.isRequired,
    active: PropTypes.number.isRequired,
    inactive: PropTypes.number.isRequired,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
  wallet: PropTypes.string,
  profile: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  workersCount: getWorkersCount(state),
  isLoading: getMinersLoading(state),
  wallet: walletSelector(state),
  profile: profileSelector(state),
});

export default connect(mapStateToProps)(withRouter(Miners));



// WEBPACK FOOTER //
// /src/components/pages/dashboard/Miners.jsx